const track = ({ href, pathname, search }) => {
  if ( window.ahoy ) {
    window.ahoy.trackView({ page: pathname, url: href });
  }

  if ( window.analytics ) {
    const analyticsData = { path: pathname, search, url: href };
    if ( document.getElementById( 'cart_item_product_id' )) {
      analyticsData.product_id = document.getElementById( 'cart_item_product_id' ).value;
    }
    window.analytics.page( analyticsData );
  }
};

export const PageViewTracker = {
  track,
};
